import { render } from "./TestContent.vue?vue&type=template&id=13443aac&scoped=true&ts=true"
import script from "./testContentHelper.ts?vue&type=script&lang=ts"
export * from "./testContentHelper.ts?vue&type=script&lang=ts"

import "./TestContent.vue?vue&type=style&index=0&id=13443aac&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13443aac"]])

export default __exports__